(function(){
  function tidy(){
    var d=document.querySelector('.product__description');
    if(!d||d.dataset.fsDone)return;
    if(d.querySelector('li'))return;
    var ps=d.querySelectorAll('p');
    if(!ps.length)return;
    var changed=false;
    Array.prototype.forEach.call(ps,function(p){
      var txt=(p.textContent||'').trim();
      if(p.querySelector('img,a,br'))return;
      var parts=txt.split(/\s+-\s+|^-\s+/).map(function(s){return s.trim()}).filter(Boolean);
      if(parts.length<3)return;
      var ul=document.createElement('ul');
      parts.forEach(function(s){
        s=s.replace(/^[-–•]\s*/,'').trim();
        if(!s)return;
        var li=document.createElement('li');
        li.textContent=s;
        ul.appendChild(li);
      });
      if(ul.children.length>=3){p.parentNode.replaceChild(ul,p);changed=true;}
    });
    if(changed)d.dataset.fsDone='1';
  }
  function run(){try{tidy()}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
/* fs-color-media */
(function(){
  function pickThumb(idx){
    var thumbs = document.querySelectorAll(".thumbnail-list__item .thumbnail");
    if(thumbs.length > idx && thumbs[idx]){ thumbs[idx].click(); return true; }
    return false;
  }
  function isRenk(node){
    var fs = node.closest ? node.closest("fieldset, .product-form__input") : null;
    if(!fs) return false;
    var lab = fs.querySelector("legend, label.form__label");
    return !!lab && lab.textContent.toLocaleLowerCase("tr").indexOf("renk") > -1;
  }
  function handle(val){
    var v = (val || "").trim().toLocaleLowerCase("tr");
    if(!v) return;
    var idx = (v.indexOf("beyaz") > -1) ? 1 : 0;
    setTimeout(function(){ pickThumb(idx); }, 60);
  }
  document.addEventListener("change", function(e){
    var el = e.target;
    if(!el) return;
    if(el.tagName === "SELECT" && isRenk(el)){ handle(el.value); return; }
    if(el.type === "radio" && isRenk(el)){ handle(el.value); }
  }, true);
})();


/* ---- Beden tablosu bagi (26.08.2026) ---- */
(function(){
  var modal = null, lastFocus = null;
  var EN = (document.documentElement.getAttribute("lang")||"tr").toLowerCase().indexOf("en") === 0;
  var L = EN ? {label:"Size guide", title:"Size guide", close:"Close", opt:"size"} : {label:"Beden tablosu", title:"Beden tablosu", close:"Kapat", opt:"beden"};
  function buildModal(){
    var src = document.querySelector("#fs-beden .fs-sizetable");
    if(!src) return null;
    var wrap = document.createElement("div");
    wrap.className = "fs-modal";
    wrap.setAttribute("role","dialog");
    wrap.setAttribute("aria-modal","true");
    wrap.setAttribute("aria-label", L.title);
    wrap.hidden = true;
    var box = document.createElement("div");
    box.className = "fs-modal-box";
    var head = document.createElement("div");
    head.className = "fs-modal-head";
    var h = document.createElement("h2");
    h.className = "fs-modal-title";
    h.textContent = L.title;
    var x = document.createElement("button");
    x.type = "button";
    x.className = "fs-modal-x";
    x.setAttribute("aria-label", L.close);
    x.innerHTML = "<svg viewBox=\"0 0 20 20\" width=\"18\" height=\"18\" aria-hidden=\"true\"><path d=\"M4 4l12 12M16 4L4 16\" stroke=\"currentColor\" stroke-width=\"1.6\" fill=\"none\" stroke-linecap=\"round\"/></svg>";
    head.appendChild(h); head.appendChild(x);
    box.appendChild(head);
    box.appendChild(src.cloneNode(true));
    wrap.appendChild(box);
    document.body.appendChild(wrap);
    x.addEventListener("click", closeModal);
    wrap.addEventListener("click", function(e){ if(e.target === wrap) closeModal(); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape" && modal && !modal.hidden) closeModal(); });
    return wrap;
  }
  function openModal(){
    if(!modal) modal = buildModal();
    if(!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add("fs-modal-open");
    var x = modal.querySelector(".fs-modal-x"); if(x) x.focus();
  }
  function closeModal(){
    if(!modal) return;
    modal.hidden = true;
    document.body.classList.remove("fs-modal-open");
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function bedenLink(){
    if(!document.querySelector("#fs-beden .fs-sizetable")) return;
    var legends = document.querySelectorAll(".product-form__input legend.form__label");
    for(var i=0;i<legends.length;i++){
      var lg = legends[i];
      var lt = (lg.textContent||"").trim().toLowerCase();
      if(lt.indexOf("beden") !== 0 && lt.indexOf("boyut") !== 0 && lt.indexOf("size") !== 0 && lt.indexOf("body") !== 0) continue;
      if(lg.parentNode.querySelector(".fs-bedenlink")) continue;
      var row = document.createElement("div");
      row.className = "fs-optrow";
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "fs-bedenlink";
      btn.textContent = L.label;
      btn.addEventListener("click", openModal);
      lg.parentNode.insertBefore(row, lg);
      row.appendChild(lg);
      row.appendChild(btn);
    }
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", bedenLink); } else { bedenLink(); }
  document.addEventListener("shopify:section:load", function(){ modal = null; bedenLink(); });
  var t = setInterval(bedenLink, 700); setTimeout(function(){ clearInterval(t); }, 6000);
})();

/* ==== Kurumsal sayfalar (26.08.2026) ==== */
(function(){
  var root = document.getElementById("fs-page");
  if(!root) return;
  var host = root.closest(".page-width");
  if(host){ host.classList.add("fs-page-host"); }
  var t = document.querySelector(".main-page-title");
  if(t && t.parentNode){ t.parentNode.removeChild(t); }

  var LAT = 40.9757215, LON = 28.8753248;
  var FTID = "0x14cabca4e49c5afb:0x91fbd28bff753f53";
  var openUrl = "https://www.google.com/maps?q=" + encodeURIComponent("Fame Stoned") + "&ftid=" + FTID;
  var dirUrl  = "https://www.google.com/maps/dir/?api=1&destination=" + LAT + "%2C" + LON;
  var embUrl  = "https://maps.google.com/maps?q=" + LAT + "," + LON + "&z=17&hl=tr&output=embed";
  root.querySelectorAll("[data-maps=\"open\"]").forEach(function(a){ a.href = openUrl; a.target="_blank"; a.rel="noopener"; });
  root.querySelectorAll("[data-maps=\"dir\"]").forEach(function(a){ a.href = dirUrl; a.target="_blank"; a.rel="noopener"; });
  root.querySelectorAll("[data-fsmap]").forEach(function(box){
    var f = document.createElement("iframe");
    f.src = embUrl; f.loading = "lazy"; f.title = "Fame Stoned — Bakırköy";
    f.referrerPolicy = "no-referrer-when-downgrade"; f.allowFullscreen = true;
    box.appendChild(f);
  });

  var dot = root.querySelector("[data-open-dot]"), txt = root.querySelector("[data-open-txt]");
  if(dot && txt){
    var tick = function(){
      var h = 12;
      try{ h = parseInt(new Intl.DateTimeFormat("tr-TR",{timeZone:"Europe/Istanbul",hour:"2-digit",hour12:false}).format(new Date()),10); }
      catch(e){ h = new Date().getHours(); }
      var acik = (h >= 10 && h < 21);
      if(acik){ dot.classList.add("on"); } else { dot.classList.remove("on"); }
      var EN = (document.documentElement.getAttribute("lang")||"tr").toLowerCase().indexOf("en") === 0;
      if(EN){ txt.textContent = acik ? "Open now" : "Closed now"; }
      else { txt.textContent = acik ? "Mağaza şu an açık" : "Mağaza şu an kapalı"; }
    };
    tick(); setInterval(tick, 60000);
  }

  root.querySelectorAll("[data-copy]").forEach(function(b){
    b.addEventListener("click", function(){
      var v = b.getAttribute("data-copy");
      var done = function(){ var o=b.innerHTML; b.classList.add("copied"); b.innerHTML = ((document.documentElement.getAttribute("lang")||"tr").toLowerCase().indexOf("en")===0) ? "Copied" : "Kopyalandı"; setTimeout(function(){ b.innerHTML=o; b.classList.remove("copied"); },1500); };
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(v).then(done, done); }
      else { var t2=document.createElement("textarea"); t2.value=v; document.body.appendChild(t2); t2.select(); try{document.execCommand("copy");}catch(e){} document.body.removeChild(t2); done(); }
    });
  });
})();
